var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-app-bar',{staticClass:"toolbar__content elevation-0 px-0",attrs:{"color":"white"}},[_vm._t("default",function(){return [_c('TheBreadcrumb',{attrs:{"items":_vm.$route.meta.breadcrumb}})]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }